<div
  class="bg-surface-950/50 absolute size-full"
  [class]="{
    'backdrop-blur-sm': blur(),
  }"
></div>
